import _regeneratorRuntime from "/app/node_modules/@babel/runtime/helpers/esm/regeneratorRuntime.js";
import _toConsumableArray from "/app/node_modules/@babel/runtime/helpers/esm/toConsumableArray.js";
import _asyncToGenerator from "/app/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js";
import "core-js/modules/es.array.concat.js";
import "core-js/modules/es.array.find.js";
import "core-js/modules/es.array.map.js";
import "core-js/modules/es.array.push.js";
import "core-js/modules/es.object.to-string.js";
import { request } from "@/js/http/http_request";
import { hasRole, getLoggedUserData, isAdminNotConsultant, isUserBuyerGroup, isHolding, isConsultantOrHolding, isConsultantNotHolding } from "@/js/http/auth.js";
import { listWineRangeAccessibility, TASTING_PHOTOS, IS_STRIPE_ENABLED } from "@/js/lists.ts";
export function getMenuItems() {
  return _getMenuItems.apply(this, arguments);
}
function _getMenuItems() {
  _getMenuItems = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee() {
    var loggedUserData, isHoldingData, isConsultantOrHoldingData, isBuyer, myStatus, labelStatus, menus, _requiredResponse$dat, filterUserIds, _responseUsers$data, responseUsers, otherUserIds, hasTastingMenu, requiredSearch, paramsQuery, requiredResponse, _takenResponse$data, takenSearch, _paramsQuery, takenResponse;
    return _regeneratorRuntime().wrap(function _callee$(_context) {
      while (1) switch (_context.prev = _context.next) {
        case 0:
          loggedUserData = getLoggedUserData();
          isHoldingData = isHolding(loggedUserData);
          isConsultantOrHoldingData = isConsultantOrHolding(loggedUserData);
          isBuyer = hasRole(process.env.VUE_APP_ROLES_BUYER);
          _context.next = 6;
          return getMyStatus(loggedUserData);
        case 6:
          myStatus = _context.sent;
          labelStatus = myStatus ? listWineRangeAccessibility.find(function (x) {
            return x.id == myStatus.rangeAccessibility;
          }).textForUsers : null;
          menus = [{
            id: "profile",
            label: "My profile",
            route: "userProfile",
            tab: "profile",
            status: labelStatus
          }];
          if (isHoldingData) {
            menus.push({
              id: "favorites",
              label: "My favorites",
              route: "userProfile",
              tab: "favorites"
            });
            if (IS_STRIPE_ENABLED && hasRole(process.env.VUE_APP_ROLES_MANAGE_WALLET)) {
              menus.push({
                id: "wallet",
                label: "My wallet",
                route: "userProfile",
                tab: "wallet"
              });
            }
          } else if (isConsultantNotHolding(loggedUserData)) {
            menus.push({
              id: "credit-notes",
              label: "My credits",
              route: "userProfile",
              tab: "creditNotes"
            }, {
              id: "favorites",
              label: "My favorites",
              route: "userProfile",
              tab: "favorites"
            });
            if (IS_STRIPE_ENABLED) {
              menus.push({
                id: "wallet",
                label: "My wallet",
                route: "userProfile",
                tab: "wallet"
              });
            }
          } else if (isBuyer) {
            menus.push({
              id: "orders",
              label: "My orders",
              route: "userProfile",
              tab: "orders"
            }, {
              id: "credit-notes",
              label: "My credits",
              route: "userProfile",
              tab: "creditNotes"
            }, {
              id: "favorites",
              label: "My favorites",
              route: "userProfile",
              tab: "favorites"
            });
            if (IS_STRIPE_ENABLED) {
              menus.push({
                id: "wallet",
                label: "My wallet",
                route: "userProfile",
                tab: "wallet"
              });
            }
          } else {
            menus.push({
              id: "favorites",
              label: "My favorites",
              route: "userProfile",
              tab: "favorites"
            });
          }
          if (!isAdminNotConsultant(loggedUserData)) {
            _context.next = 14;
            break;
          }
          if (hasRole(process.env.VUE_APP_ROLES_MANAGE_TASTING_PHOTOS)) {
            menus = [].concat(_toConsumableArray(menus), [{
              id: "adminTastingPhotos",
              label: "Tasting photos",
              route: "adminTastingPhotos"
            }]);
          }
          _context.next = 29;
          break;
        case 14:
          filterUserIds = [+loggedUserData.idUser];
          if (!isConsultantOrHoldingData) {
            _context.next = 20;
            break;
          }
          _context.next = 18;
          return request("/v1/third-party-users", "get", {}, true, "api").catch(function () {});
        case 18:
          responseUsers = _context.sent;
          if ((responseUsers === null || responseUsers === void 0 || (_responseUsers$data = responseUsers.data) === null || _responseUsers$data === void 0 || (_responseUsers$data = _responseUsers$data.value) === null || _responseUsers$data === void 0 ? void 0 : _responseUsers$data.length) > 0) {
            otherUserIds = responseUsers.data.value.map(function (x) {
              return x.id_user;
            });
            filterUserIds = [].concat(_toConsumableArray(filterUserIds), _toConsumableArray(otherUserIds));
          }
        case 20:
          hasTastingMenu = false;
          requiredSearch = {
            userIds: filterUserIds,
            allowedStatus: [TASTING_PHOTOS.REQUIRED.STATUS.TO_TAKE.id, TASTING_PHOTOS.REQUIRED.STATUS.PARTIALLY_TAKEN.id, TASTING_PHOTOS.REQUIRED.STATUS.FULLY_TAKEN.id]
          };
          paramsQuery = Object.encodeToUri(requiredSearch);
          _context.next = 25;
          return request("/v1/tasting-photos/required/any?params=".concat(paramsQuery), "get", null, true, "api").catch(function () {});
        case 25:
          requiredResponse = _context.sent;
          if ((requiredResponse === null || requiredResponse === void 0 || (_requiredResponse$dat = requiredResponse.data) === null || _requiredResponse$dat === void 0 ? void 0 : _requiredResponse$dat.value) === true) {
            hasTastingMenu = true;
          }
          if (!hasTastingMenu) {
            takenSearch = {
              targetedUserIds: filterUserIds,
              allowedStatus: [TASTING_PHOTOS.TAKEN.STATUS.TO_TRANSFER.id, TASTING_PHOTOS.TAKEN.STATUS.TRANSFERRED.id]
            };
            _paramsQuery = Object.encodeToUri(takenSearch);
            takenResponse = request("/v1/tasting-photos/any?params=".concat(_paramsQuery), "get", null, true, "api").catch(function () {});
            if ((takenResponse === null || takenResponse === void 0 || (_takenResponse$data = takenResponse.data) === null || _takenResponse$data === void 0 ? void 0 : _takenResponse$data.value) === true) {
              hasTastingMenu = true;
            }
          }
          if (hasTastingMenu) {
            menus = [].concat(_toConsumableArray(menus), [{
              id: "userTastingPhotos",
              label: "Tasting photos",
              route: "userTastingPhotos"
            }]);
          }
        case 29:
          if (hasRole(process.env.VUE_APP_ROLES_MANAGE_SETTINGS)) {
            menus = [].concat(_toConsumableArray(menus), [{
              id: "adminSettings",
              label: "Settings",
              route: "adminSettings"
            }]);
          }
          if (hasRole(process.env.VUE_APP_ROLES_USE_DEVELOPER_TOOLS)) {
            menus.push({
              id: "developerTools",
              label: "Developer tools",
              route: "developerTools"
            });
          }
          return _context.abrupt("return", menus);
        case 32:
        case "end":
          return _context.stop();
      }
    }, _callee);
  }));
  return _getMenuItems.apply(this, arguments);
}
export var HAS_DELIVERIES = "has_deliveries";
export function getMyStatus(_x) {
  return _getMyStatus.apply(this, arguments);
}
function _getMyStatus() {
  _getMyStatus = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee2(loggedUserData) {
    var response;
    return _regeneratorRuntime().wrap(function _callee2$(_context2) {
      while (1) switch (_context2.prev = _context2.next) {
        case 0:
          if (!(!isAdminNotConsultant(loggedUserData) && (isUserBuyerGroup(loggedUserData) || isConsultantOrHolding(loggedUserData)))) {
            _context2.next = 6;
            break;
          }
          _context2.next = 3;
          return request("/v1/category-users/".concat(loggedUserData.idUser), "get", null, true, "api").catch(function (_) {});
        case 3:
          response = _context2.sent;
          if (!response) {
            _context2.next = 6;
            break;
          }
          return _context2.abrupt("return", response.data.value);
        case 6:
          return _context2.abrupt("return", null);
        case 7:
        case "end":
          return _context2.stop();
      }
    }, _callee2);
  }));
  return _getMyStatus.apply(this, arguments);
}